/**
 * Reducer to handle generic data loading and CRUD operation
 * 
 */

import produce from "immer"
import get from 'lodash/get'

import {
  LOAD_DATASET_V3,
  LOAD_DATASET_V3_SUCCESS,
  UNLOAD_DATASET_V3,
  PUB3,
  PUB3_CLEAR,
  PUB3_CONFIRM,
  INIT_UPLOADv3_SUCCESS,
  STREAM_UPLOADv3,
  STREAM_UPLOAD_v3_SUCCESS,
  FINISH_UPLOADv3,
  REMOVE_UPLOAD_v3_SUCCESS
} from "../constants";

const initialState = {
  data: {},         // loaded data
  loading: false,    // true if we are in process of loading
  validate: null,     // null if validation is ok! object with key + validation error
  closeModal: false,   // set to true if we should tell application to close modal. Will be reset on UNLOADv3
  error: null,   // set to error message if we encounter an error,
  dataset: {},  // holds dataset
  datasetLoading: {}, // true if a DATASET loading operation in ongoing,
  pubSub: {},
  uploads: {},
};

const dataReducer = (state = initialState, action) => {
  return produce(state, draft => {

    switch (action.type) {
     
      case LOAD_DATASET_V3: {
        draft.datasetLoading[action.datasetId] = true;
        break;
      }

      case LOAD_DATASET_V3_SUCCESS: {
        draft.dataset[action.datasetId] = action.data
        delete draft.datasetLoading[action.datasetId]
        break;
      }
      case UNLOAD_DATASET_V3: {
        delete draft.dataset[action.datasetId];
        break;
      }
      case PUB3: {
        if( ! draft.pubSub[action.channel]) {
          draft.pubSub[action.channel] = []
        }
        draft.pubSub[action.channel].push({
          id: action.id,
          msg: action.msg
        })
        break;
      }
      case PUB3_CLEAR: {
        draft.pubSub[action.channel] = []
        break;
      }

      case PUB3_CONFIRM: {
        const channel = get( draft, ['pubSub', action.channel], []);

        const nIndex = channel.findIndex( n => n.id === action.id)

        if( nIndex !== -1 ) {
          channel.splice(nIndex,1)
        }

        break;
      }
      
  
      case INIT_UPLOADv3_SUCCESS : {
        draft.uploads[action.assetId] = { 
          name: action.name,
          size: action.size,
          estimatedChunks: action.estimatedChunks,
          chunkId: 0,
          running: false
        }
        break;
      }
  
      case STREAM_UPLOADv3 : {
        draft.uploads[action.assetId].running = true;
        break;
      }
  
      case STREAM_UPLOAD_v3_SUCCESS : {
        draft.uploads[action.assetId].chunkId++
        draft.uploads[action.assetId].percentage = Math.floor((draft.uploads[action.assetId].chunkId / draft.uploads[action.assetId].estimatedChunks) * 100)
        draft.uploads[action.assetId].running = false;
        break;
      }
      case FINISH_UPLOADv3 : {
        draft.uploads[action.assetId].completed = true;
        break;
      }
      case REMOVE_UPLOAD_v3_SUCCESS : {
        draft.uploads[action.assetId].removed = true
        break;
      }
    
  

      default:
        break;
    }
  })
};

export default dataReducer;

export const getUploads = state => {
  return state.uploads;
};

export const getDataset3 = state => {
  return state.dataset;
};

export const getDataset3Loading = state => {
  return state.datasetLoading;
};

export const getPubSub3 = state => {
  return state.pubSub;
}
